module.exports = __webpack_public_path__ + "static/media/avatar_18.b94128c9.svg";